import posthog from 'posthog-js';

if (import.meta.env.REACT_APP_POSTHOG) {
  posthog.init(import.meta.env.REACT_APP_POSTHOG, {
    api_host: 'https://eu.i.posthog.com',
    persistence: 'sessionStorage',
    disable_persistence: true,
    disable_cookie: true,
  });
}
